import { FC } from 'react';
import { OrderPreviewLineItemRequest } from 'store/api/apiTypes';
import { StripePayment } from './stripe';

interface CheckoutProps {
  items: OrderPreviewLineItemRequest[];
  onSuccess?: (sessionId?: string) => void;
}

export const Checkout: FC<CheckoutProps> = ({ items, onSuccess }) => {
  return <StripePayment items={items} onSuccess={onSuccess} />;
};
